import ApiService from "@/common/api.service";

export default {
  fetchExchangeRate() {
    return ApiService.query("money-convert-ratio");
  }
};
